import { ClientOnErrorFunction } from "react-router";
import { noticeError } from "~/monitor.client";
import reporter, {
  isBackendHealthError,
  isReportableError,
  normalizeError,
} from "~/reporter";

export const onError: ClientOnErrorFunction = (
  error,
  { location, pattern, errorInfo },
) => {
  if (isBackendHealthError(error)) {
    noticeError(normalizeError(error), {
      route: pattern ?? "unknown",
      path: location.pathname,
    });
    return;
  }
  if (!isReportableError(error)) return;

  reporter.captureException(
    error,
    {
      route: pattern ?? "unknown",
      path: location.pathname,
    },
    { componentStack: errorInfo?.componentStack ?? undefined },
  );
};
